// PDP upgrade-sale: apply discounted price for a given variant object
// A PDP can render the '.price--upgrade-sale' wrapper up to 3 times (main price
// block, price-offer near gallery, sticky add-to-cart bar), so every match must
// be updated on variant change — not just the first one.
function applyUpgradeSalePrice(variant) {
    var priceWrappers = document.querySelectorAll('.price--upgrade-sale');
    if (!priceWrappers.length) return;

    var fmt = function(p) {
        return (typeof theme !== 'undefined' && theme.Currency)
            ? theme.Currency.formatMoney(p, window.shopSettings.moneyFormat)
            : null;
    };

    priceWrappers.forEach(function(priceWrapper) {
        var rawDiscountPercent = parseFloat(priceWrapper.getAttribute('data-discount-percent'));
        var discountPercent = isNaN(rawDiscountPercent) ? 25 : rawDiscountPercent;
        var flatDiscount = priceWrapper.getAttribute('data-flat-discount') === 'true';
        var excludedVariantIds = (priceWrapper.getAttribute('data-excluded-variant-ids') || '')
            .split(',')
            .map(function(id) { return id.trim(); })
            .filter(Boolean);
        var isExcluded = excludedVariantIds.indexOf(String(variant.id)) !== -1;
        if (isExcluded) {
            discountPercent = 0;
        }

        var displayPrice = Math.round(variant.price * (100 - discountPercent) / 100);
        var comparePrice = (flatDiscount && !isExcluded)
            ? variant.price
            : (variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price);
        var discountPct = Math.round((comparePrice - displayPrice) * 100 / comparePrice);

        var saleEl = priceWrapper.querySelector('.price-item--sale bdi');
        var compareEl = priceWrapper.querySelector('.price__compare bdi');
        var badge = priceWrapper.querySelector('.upgrade-off-badge');

        var saleFmt = fmt(displayPrice);
        var compareFmt = fmt(comparePrice);

        if (saleEl && saleFmt) saleEl.innerHTML = saleFmt;
        if (compareEl && compareFmt) compareEl.innerHTML = compareFmt;
        if (badge) {
            if (discountPct > 0) {
                badge.textContent = '-' + discountPct + '% Off';
                badge.style.display = '';
            } else {
                badge.style.display = 'none';
            }
        }
    });
}

// On page load: set price based on currently selected variant
document.addEventListener('DOMContentLoaded', function() {
    var variantRadios = document.querySelector('variant-radios[data-section]');
    if (!variantRadios) return;
    if (!document.querySelector('.price--upgrade-sale')) return;

    var scriptTag = variantRadios.querySelector('script[type="application/json"]');
    if (!scriptTag) return;

    var variantData = JSON.parse(scriptTag.textContent);

    // Get selected options from checked radio inputs
    var fieldsets = variantRadios.querySelectorAll('fieldset');
    var selectedOptions = Array.from(fieldsets).map(function(fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
    });

    // Also check URL param as fallback
    var urlVariantId = new URLSearchParams(window.location.search).get('variant');

    var variant = null;
    if (urlVariantId) {
        variant = variantData.find(function(v) { return String(v.id) === urlVariantId; });
    }
    if (!variant) {
        variant = variantData.find(function(v) {
            return selectedOptions.every(function(opt, i) { return v.options[i] === opt; });
        });
    }

    if (variant) applyUpgradeSalePrice(variant);
});

// Track current variant so productInfo:loaded can re-apply after section render overwrites price
var _upgradeSaleCurrentVariant = null;

// On variant change: update discounted price immediately and store variant
document.addEventListener('variant:change', function(event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;
    if (document.querySelector('.price--upgrade-sale')) {
        _upgradeSaleCurrentVariant = variant;
        applyUpgradeSalePrice(variant);
    }
});

// After section rendering completes (renderProductInfo), re-apply because updatePrice() overwrites innerHTML
document.addEventListener('productInfo:loaded', function() {
    if (_upgradeSaleCurrentVariant && document.querySelector('.price--upgrade-sale')) {
        applyUpgradeSalePrice(_upgradeSaleCurrentVariant);
    }
});

// Swap the card's product image to the clicked/preselected variant's image, if it has one
function updateCardProductImage(card, label) {
    const src = label.getAttribute('data-src');
    if (!src) return;
    const image = card.querySelector('.card__media .media img');
    if (!image) return;
    image.src = src;
    const srcset = label.getAttribute('data-srcset');
    if (srcset) image.srcset = srcset;
}

// Delegated on document (not attached per-label) so clicks keep working on cards
// rendered after page load too: filter/sort re-renders, load-more, quick-view,
// recently-viewed/related sections, search results, etc.
document.addEventListener('click', (event) => {
    const label = event.target.closest('.cardproduct_variant label');
    if (!label) return;

    const value = label.getAttribute('value');
    const price = label.getAttribute('price');
    const comprice = label.getAttribute('comprice');
    const discount = label.getAttribute('discount');
    const card = label.closest('.card-wrapper');

    if (!card) return;

    const button = card.querySelector('.add-to-cart');
    const priceDiv = card.querySelector('.price__regular bdi');
    const salePrice = card.querySelector('.price-item--sale bdi');
    const salecomPrice = card.querySelector('.price__compare bdi');
    const badge = card.querySelector('.upgrade-off-badge');
    const priceWrapper = card.querySelector('.price--upgrade-sale');
    // Top-of-image "-XX% Off" badge (card__badge > .card__discount-badge) — keep
    // it in sync with whichever variant is currently selected, same as the
    // price-upgrade-sale badge above.
    const discountBadge = card.querySelector('.card__discount-badge');

    updateCardProductImage(card, label);

    if (button) {
        button.setAttribute('data-variant-id', value);
    }

    const discountPct = parseInt(discount, 10) || 0;
    if (priceWrapper) priceWrapper.classList.toggle('price--on-sale', discountPct > 0);

    if (price) {
        const formattedPrice = price.endsWith('.00') ? price.replace('.00', '') : price;
        if (priceDiv) priceDiv.textContent = formattedPrice;
        if (salePrice) salePrice.textContent = formattedPrice;
    }
    if (comprice) {
        const formattedcomPrice = comprice.endsWith('.00') ? comprice.replace('.00', '') : comprice;
        if (salecomPrice) salecomPrice.textContent = formattedcomPrice;
    }
    if (badge) {
        if (discountPct > 0) {
            badge.textContent = '-' + discountPct + '% Off';
            badge.style.display = '';
        } else {
            badge.style.display = 'none';
        }
    }
    if (discountBadge) {
        if (discountPct > 0) {
            discountBadge.textContent = '–' + discountPct + '% off';
            discountBadge.style.display = '';
        } else {
            discountBadge.style.display = 'none';
        }
    }

    // Remove 'selected' from all labels in this card only
    const allLabelsInCard = card.querySelectorAll('.cardproduct_variant label');
    allLabelsInCard.forEach(l => l.classList.remove('selected'));
    label.classList.add('selected');
});

// --- Pre-selection logic: sets each card's initial visual state to match
// whichever variant is already selected ---
function preselectCardVariant(label) {
    const card = label.closest('.card-wrapper');
    if (!card) return;

    const priceDiv = card.querySelector('.price__regular bdi');
    const salePrice = card.querySelector('.price-item--sale bdi');
    const salecomPrice = card.querySelector('.price__compare bdi');
    const preselectBadge = card.querySelector('.upgrade-off-badge');
    const preselectPriceWrapper = card.querySelector('.price--upgrade-sale');
    const preselectDiscountBadge = card.querySelector('.card__discount-badge');
    const labelValue = label.getAttribute('value');
    const labelPrice = label.getAttribute('price');
    const labelcomprice = label.getAttribute('comprice');
    const labelDiscount = label.getAttribute('discount');

    // Read the default variant off the card itself, not the add-to-cart button:
    // cards with quick view enabled render a <quick-view-button> instead, which
    // has no data-variant-id, so relying on '.add-to-cart' left every label
    // unselected (no border) on those cards.
    if (card.getAttribute('data-default-variant-id') === labelValue) {
        const allLabelsInCard = card.querySelectorAll('.cardproduct_variant label');
        allLabelsInCard.forEach(l => l.classList.remove('selected'));
        label.classList.add('selected');

        updateCardProductImage(card, label);

        const preselectDiscountPct = parseInt(labelDiscount, 10) || 0;
        if (preselectPriceWrapper) preselectPriceWrapper.classList.toggle('price--on-sale', preselectDiscountPct > 0);

        if (labelPrice) {
            const formattedPrice = labelPrice.endsWith('.00') ? labelPrice.replace('.00', '') : labelPrice;
            if (priceDiv) priceDiv.textContent = formattedPrice;
            if (salePrice) salePrice.textContent = formattedPrice;
        }
        if (labelcomprice) {
            const formattedcomPrice = labelcomprice.endsWith('.00') ? labelcomprice.replace('.00', '') : labelcomprice;
            if (salecomPrice) salecomPrice.textContent = formattedcomPrice;
        }
        if (preselectBadge) {
            if (preselectDiscountPct > 0) {
                preselectBadge.textContent = '-' + preselectDiscountPct + '% Off';
                preselectBadge.style.display = '';
            } else {
                preselectBadge.style.display = 'none';
            }
        }
        if (preselectDiscountBadge) {
            if (preselectDiscountPct > 0) {
                preselectDiscountBadge.textContent = '–' + preselectDiscountPct + '% off';
                preselectDiscountBadge.style.display = '';
            } else {
                preselectDiscountBadge.style.display = 'none';
            }
        }
    }
}

document.querySelectorAll('.cardproduct_variant label').forEach(preselectCardVariant);

// Cards can also arrive after this script has already run — filter/sort
// re-renders, load-more/infinite scroll, recommendation/recently-viewed
// sections, section-rendering API fetches, quick view, etc. Watch the DOM so
// those get their default-variant selection (and border) applied too.
new MutationObserver((mutations) => {
    for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
            if (node.nodeType !== 1) continue;
            if (node.matches && node.matches('.cardproduct_variant label')) {
                preselectCardVariant(node);
            }
            if (node.querySelectorAll) {
                node.querySelectorAll('.cardproduct_variant label').forEach(preselectCardVariant);
            }
        }
    }
}).observe(document.body, { childList: true, subtree: true });
// $('.announcement-slide').owlCarousel({
//     items: 1,
//     loop: true,
//     autoplay: true,
//     autoplayTimeout: 4000, // 2 seconds between slides
//     autoplaySpeed: 3000, // 2 seconds transition animation
//     autoplayHoverPause: true,
//     dots: false,
//     smartSpeed: 1000,
//     nav: false,
// });

document.addEventListener("DOMContentLoaded", function() {
    var payButton = document.querySelector('[data-tg-refresh="payment_gateway"]');
    if (payButton) {
        payButton.style.display = "none";
    }
});
// Owl Carousel hardcodes role="presentation" on its generated nav buttons and
// leaves the nav icons without alt/aria text, so fix both up once the nav exists.
// owlCarousel() builds the nav and fires 'initialized.owl.carousel' synchronously
// during its own call, so binding to that event afterwards is always too late —
// patch the nav directly instead, then re-patch on any later 'refreshed' event.
function fixOwlNavAccessibility($carousel) {
    function patch() {
        var $nav = $carousel.find('.owl-nav');
        $nav.find('.owl-prev').attr('role', 'button').attr('aria-label', 'Previous slide');
        $nav.find('.owl-next').attr('role', 'button').attr('aria-label', 'Next slide');
        $nav.find('.owl-prev img, .owl-next img').attr('alt', '');
        $nav.find('.owl-prev svg, .owl-next svg').attr('aria-hidden', 'true');
    }
    patch();
    $carousel.on('refreshed.owl.carousel', patch);
}

$('.hero-products-slider__carousel').owlCarousel({
    loop: true,
    margin: 20,
    nav: true,
    dots: false,
    navText: ['<img src="https://cdn.shopify.com/s/files/1/0712/5621/1737/files/icons8-back-50.png?v=1751521128">', '<img src="https://cdn.shopify.com/s/files/1/0712/5621/1737/files/icons8-forward-50.png?v=1751521128">'],
    responsive: {
        0: {
            items: 1,
            margin: 6
        },
        768: {
            items: 2
        },
        1024: {
            items: 2
        }
    }
});
fixOwlNavAccessibility($('.hero-products-slider__carousel'));

$('.npdp_available_offers_slider').owlCarousel({
    loop: true,
    margin: 15,
    nav: false,
    dots: false,
    navText: ['<img src="https://cdn.shopify.com/s/files/1/0712/5621/1737/files/icons8-back-50.png?v=1751521128">', '<img src="https://cdn.shopify.com/s/files/1/0712/5621/1737/files/icons8-forward-50.png?v=1751521128">'],
    responsive: {
        0: {
            items: 1.3, // Show 3 slides on mobile
            margin: 5
        },
        768: {
            items: 2 // Show 1 slide on desktop
        },
        1024: {
            items: 2 // Show 1 slide on desktop
        }
    }
});

function copyToClipboard(el) {
    const code = el.querySelector('.copy-code').innerText.trim();
    if (!code) return;
    navigator.clipboard.writeText(code).then(() => {
        const tooltip = el.querySelector('.tooltip');
        tooltip.style.visibility = 'visible';
        tooltip.style.opacity = '1';
        tooltip.innerText = 'Copied!';

        setTimeout(() => {
            tooltip.style.visibility = 'hidden';
            tooltip.style.opacity = '0';
        }, 1500);
    });
}
document.addEventListener('DOMContentLoaded', function() {
    const triggerLink = document.querySelector('a.why-it-works');
    const scrollTarget = document.getElementById('collapsible-content');

    if (triggerLink && scrollTarget) {
        triggerLink.addEventListener('click', function(e) {
            e.preventDefault(); // prevent default link behavior

            scrollTarget.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        });
    }
});
const announcementBar = document.querySelector('.custom-announcement');
if (announcementBar) {
    window.onscroll = function() {
        const offsetTop = announcementBar.offsetTop;

        // Check if we've scrolled past the original position of the announcement bar
        if (window.scrollY > offsetTop) {
            // Add the sticky class if the scroll is past the bar's position
            announcementBar.classList.add('sticky');
        } else {
            // Remove the sticky class when scrolling back up
            announcementBar.classList.remove('sticky');
        }
    }
}; 
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    const targetId = this.getAttribute('href');
    const targetEl = document.querySelector(targetId);

    if (targetId.length > 1 && targetEl) {
      e.preventDefault();

      const offset = 65; // yahan jitna minus chahiye (header height)
      const elementPosition = targetEl.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  });
});
   $('.logo_slider').owlCarousel({
       loop: true,
       dots:false,
       nav:true,
       navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/></svg>','<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/></svg>'],
       responsive: {
       0: { items: 2 },
       768: { items: 4
       },
       1024: { items: 5 },
       1280: { items: 5 }
       }
       });
       fixOwlNavAccessibility($('.logo_slider'));
        $('.block_slider').owlCarousel({
       loop: true,
       dots:false,
       nav:true,
       navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/></svg>','<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/></svg>'],
       responsive: {
       0: { items: 2 },
       768: { items: 4
       },
       1024: { items: 5 },
       1280: { items: 5 }
       }
       });
       fixOwlNavAccessibility($('.block_slider'));
       $('.slider_imaqge').owlCarousel({
    items: 1,
    loop: true,
    autoplay: true,
    autoplayTimeout: 4000, 
    autoplaySpeed: 3000, 
    autoplayHoverPause: true,
    dots: true,
    smartSpeed: 1000,
    nav: false,
});
$('.image-carousel').owlCarousel({
       loop: true,
       dots:false,
       nav:false,
       margin: 10,
       responsive: {
       0: { items: 1.6 },
       768: { items: 4
       },
       1024: { items: 6 },
       1280: { items: 6 }
       }
});
$('.video-carousel').owlCarousel({
       loop: true,
       dots:false,
       nav:false,
        margin: 10,
       responsive: {
       0: { items: 2 },
       768: { items: 4
       },
       1024: { items: 7 },
       1280: { items: 7 }
       }
});
 document.querySelector('.delivery').addEventListener('click', function (e) {
    e.preventDefault();

    const targetClass = this.getAttribute('href'); // .about-section
    const targetEl = document.querySelector('.clickpost-edd__heading');

    if (!targetEl) return;

    const offset = 65; // header height
    const targetPosition =
      targetEl.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  });
